import { Component, contentChild, inject, NgZone, OnInit, TemplateRef } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { HeaderComponent } from './components/header/header.component';
import { BUILD_CONFIG, ENVIRONMENT } from 'src/app/providers/environment';
import { FooterComponent } from 'src/app/components/footer/footer.component';
import { resolveLocale } from 'src/app/utils/resolve-locale/resolve-locale';
import { TRANSLATIONS } from 'src/app/utils/translations/translations';

declare global {
  interface Window {
    Beacon: (action: string, parameter?: string) => void;
    Cypress: unknown;
    Rollbar: {
      error: (...args: unknown[]) => void;
      log: (...args: unknown[]) => void;
    };
  }
}

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  standalone: true,
  imports: [FooterComponent, RouterOutlet, HeaderComponent],
})
export class AppComponent implements OnInit {
  private readonly ngZone = inject(NgZone);
  private readonly env = inject(ENVIRONMENT);
  private readonly translate = inject(TranslateService);

  readonly BUILD_CONFIG = BUILD_CONFIG;

  headerTemplate = contentChild.required<TemplateRef<unknown>>('header');
  contentTemplate = contentChild.required<TemplateRef<unknown>>('content');

  constructor() {
    // AppComponent is constructed before the router resolves the first
    // navigation, so ActivatedRoute's query params are empty here — read
    // straight off the document URL instead (reliable for the iframe pages
    // the theme extension embeds, which put `locale` directly on the URL).
    const raw = new URLSearchParams(window.location.search).get('locale');

    for (const [lang, translation] of Object.entries(TRANSLATIONS))
      this.translate.setTranslation(lang, translation);
    this.translate.setFallbackLang('en');
    this.translate.use(resolveLocale(raw));
  }

  ngOnInit(): void {
    this.ngZone.runOutsideAngular(() => {
      // if (BUILD_CONFIG === 'production')
      //   amplitude.initAll(this.env.amplitudeKey, {
      //     analytics: {
      //       serverUrl: `${this.env.server}/ap/al`,
      //       autocapture: {
      //         attribution: true,
      //         fileDownloads: true,
      //         formInteractions: true,
      //         pageViews: true,
      //         sessions: true,
      //         elementInteractions: true,
      //         networkTracking: true,
      //         webVitals: true,
      //         frustrationInteractions: true,
      //       },
      //     },
      //     // sessionReplay: {
      //     //   serverUrl: this.env.server,
      //     //   configServerUrl: `${this.env.server}/ap/ss-c`,
      //     //   trackServerUrl: `${this.env.server}/ap/ss`,
      //     //   sampleRate: 0,
      //     // },
      //   });
    });
  }
}
